import { phaseLabel } from "./flowProgressBanner";

export function runStatusLabel(status) {
    if (status === "completed") return "concluído";
    if (status === "failed") return "falhou";
    if (status === "queued" || status === "running") return "rodando";
    return status ? String(status) : "—";
}

export default function TheaterChrome({ title, status, progress, onBack }) {
    const turnPart =
        progress?.turnIndex != null && progress?.turnTotal != null
            ? `${progress.turnIndex}/${progress.turnTotal}`
            : null;
    const phase = progress?.phase != null ? phaseLabel(progress.phase) : null;
    const progressText = [turnPart && `turno ${turnPart}`, phase].filter(Boolean).join(" · ");

    return (
        <div
            className="sticky top-0 z-20 mb-3 flex flex-wrap items-center gap-2 rounded-lg border border-[#b47c06]/50 bg-gray-950/95 px-3 py-2 backdrop-blur"
            data-testid="theater-chrome"
            role="region"
            aria-label="Acompanhamento da execução"
        >
            <button
                type="button"
                onClick={onBack}
                className="rounded border border-gray-600 px-2 py-1 text-xs text-gray-100 hover:border-laranjinha"
            >
                ← Voltar à suíte
            </button>
            <p className="min-w-0 flex-1 truncate text-sm font-medium text-white">{title || "Execução"}</p>
            <span
                data-testid="theater-status"
                className="rounded bg-gray-800 px-2 py-0.5 text-[11px] uppercase tracking-wide text-amber-100"
            >
                {runStatusLabel(status)}
            </span>
            {progressText ? (
                <span data-testid="theater-progress" className="text-[11px] text-gray-300">
                    {progressText}
                </span>
            ) : null}
        </div>
    );
}
